<template>
  <feature-toggle :toggle="createWorkpackageReadsFromDatabricks">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="refresh-from-feed-wrapper">
          <v-switch
            :label="$t('workPackages.refreshFromFeed')"
            :input-value="createWorkpackageRefreshFromFeed"
            :disabled="isDisabled || forceDisabled"
            primary
            hide-details
            class="font-weight-regular"
            @change="toggleRefreshFromFeed"
          />
        </div>
      </v-col>
    </v-row>
  </feature-toggle>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { createWorkpackageReadsFromDatabricks } from '@enums/feature-flags';

/**
 * RefreshOnCreateToggle
 *
 * This component displays a toggle switch allowing users to enable or disable
 * the "Refresh from Feed" feature when creating or copying a work package.
 *
 */
export default {
  props: {
    forceDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      createWorkpackageReadsFromDatabricks,
    };
  },

  computed: {
    ...mapState('workpackages', [
      'createWorkpackageRefreshFromFeed',
      'createWorkpackageOptimisePrices',
    ]),

    isDisabled() {
      return !this.createWorkpackageOptimisePrices;
    },
  },

  methods: {
    ...mapMutations('workpackages', ['setCreateWorkpackageRefreshFromFeed']),

    toggleRefreshFromFeed(value) {
      this.setCreateWorkpackageRefreshFromFeed(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.refresh-from-feed-wrapper {
  height: 45px;
  padding-top: 4px;
}
</style>
